require("./theme-vendor");
require("./wc-dear");
window.b2b = window.b2b || {};

/**
 * Check if a node is blocked for processing.
 *
 * @param {JQuery Object} $node
 * @return {bool} True if the DOM Element is UI Blocked, false if not.
 */
b2b.is_blocked = function( $node ) {
    return $node.is( '.processing' ) || $node.parents( '.processing' ).length;
};

/**
 * Block a node visually for processing.
 *
 * @param {JQuery Object} $node
 */
b2b.block = function( $node ) {
    if ( ! b2b.is_blocked( $node ) ) {
        $node.addClass( 'processing' ).block( {
            message: null,
            overlayCSS: {
                background: '#fff',
                opacity: 0.2
            }
        } );
    }
};
b2b.current_modal = null;

$(document).on("b2b_modal_opened", function (event, $modal){
    if(b2b.current_modal) {
        $(b2b.current_modal).removeClass('active');
        let $bodyClass = $(b2b.current_modal).attr('data-bd-class');
        if($bodyClass && $bodyClass !== '') {
            $(document.body).removeClass($bodyClass);
        }
    }
    b2b.current_modal = $modal;
})
$(document).on("b2b_modal_closed", function (event){
    b2b.current_modal = null;
})


/**
 *  Refresh the MiniCart
 *  Required after removing or adding a new product
 */
b2b.render_fragment_response = function (response) {
    if(typeof response === 'string') {
        response = JSON.parse(response);
    }
    if ( response && response.fragments ) {
        $.each( response.fragments, function( key, value ) {
            $( key ).html( value );
        });

        $( document.body ).trigger( 'b2b_fragments_refreshed' );

        if(response.cart_hash) {
            b2b.set_cart_hash( response.cart_hash );
            b2b.set_cart_creation_timestamp();
        }
        if(response.cart_items) {
            $( document.body ).trigger( 'b2b_cart_items_refreshed', response );
            let $cartCounterEle = $('a.cart-icon');
            let $totalQty = 0;
            response.cart_items.forEach(function (cartItem){
                let qty = parseInt(cartItem.qty);
                if(qty) {
                    $totalQty += qty;
                }
            });
            if($cartCounterEle.length) {
                $cartCounterEle.attr('data-cart-count',$totalQty);
            }
            if($totalQty <= 0 || !$totalQty) {
                $cartCounterEle.removeAttr('data-cart-count');
            }
        }
        // Hide or Shop Proceed to cart Button
        if(response.cart_items !== undefined && response.cart_items.length > 0) {
            $('.cart-drawer--footer').removeClass('d-none');
        }
        if(response.cart_items !== undefined && response.cart_items.length === 0) {
            $('.cart-drawer--footer').addClass('d-none');
        }
    }
}
b2b.get_cart_fragment = function () {
    $.ajax( {
        url: b2bRequest.ajaxurl,
        type: 'POST',
        data: {
            time: new Date().getTime(),
            action: 'mini_cart_fragment'
        },
        success: function( response ) {
            b2b.render_fragment_response(response);
        },
        error: function() {
            $( document.body ).trigger( 'b2b_fragments_ajax_error' );
        }
    });
}




b2b.set_cart_creation_timestamp = function() {
    if ( window.sessionStorage ) {
        sessionStorage.setItem( 'wc_cart_created', ( new Date() ).getTime() );
    }
}

/** Set the cart hash in both session and local storage */
b2b.set_cart_hash = function ( cart_hash ) {
    if ( window.sessionStorage && wc_cart_fragments_params.cart_hash_key) {
        localStorage.setItem( wc_cart_fragments_params.cart_hash_key, cart_hash );
        sessionStorage.setItem( wc_cart_fragments_params.cart_hash_key, cart_hash );
    }
}

/**
 * Unblock a node after processing is complete.
 *
 * @param {JQuery Object} $node
 */
b2b.unblock = function( $node ) {
    $node.removeClass( 'processing' ).unblock();
};

b2b.measureResultCarouselContainer = function($container) {
    var numThumbs = $container.find('.variant-item').length
    var contW = Math.round($container.width())
    // NOTE: this is a prob if we can get slidesToShow: 4 working!
    var thumbMargin = 12
    var thumbW = 80 + thumbMargin
    var CLASS = 'no-carousel'

    if(contW >= (numThumbs * thumbW) - thumbMargin) {
        $container
            .addClass(CLASS)
            // clear any transform on the slick track to reset the thumbs position
            .find('.slick-track').css({transform: 'none'})

    } else {
        $container.removeClass(CLASS)
    }
}

$(function() {
    var menuTrigger, mainMenu, mainMenuOverlay;
    menuTrigger = $('.menu-icon.combined-svgs');
    mainMenu = $('#main-menu');
    mainMenuOverlay = $('.site-nav-scrim')
    if(menuTrigger.length && mainMenu.length && mainMenuOverlay.length) {
        menuTrigger.on('click', function (event){
            event.preventDefault();
            $(document).trigger('b2b_modal_opened', [mainMenu]);
            mainMenu.addClass('active');
            mainMenuOverlay.addClass('active');
        })
        mainMenuOverlay.on('click', function (event){
            event.preventDefault();
            $(document).trigger('b2b_modal_closed');
            mainMenu.removeClass('active');
            mainMenuOverlay.removeClass('active');
        })
        mainMenu.find('.close-icon').on('click', function (event){
            event.preventDefault();
            $(document).trigger('b2b_modal_closed');
            mainMenu.removeClass('active');
            mainMenuOverlay.removeClass('active');
        });
    }
    /**
     * INITIALIZING Cart Drawer
     */
    b2b.cartDrawer.init();

    /**
     * INITIALIZING Shop Page -  Variant Slider & switching main image
     * @type {*|jQuery|HTMLElement}
     */
    let $variantSwiper = $('.woocommerce-loop-product__variants.has-swiper .thumb-slider');
    if($variantSwiper.length) {
        $variantSlider();
        $variantImageSwatch();
    }
    b2b.shopVariantSlider = $variantSlider;
    b2b.shopVariantImageSwatch = $variantImageSwatch;
    b2b.filters.init();

    /**
     *  INITIALIZING - Single Product Page - Variant Slider
     */
    productMainVariantSlider();

    /**
     * INITIALIZING - Single Product Page - Switch Variant Info
     * Additional Info and Main Product Image slider
     */
    productViewSwitchingVariantInfo();

    /**
     *  INITIALIZING - Product Single Page - Product Form
     */
    let productContainer = $('.product-view.product');
    if(productContainer.length) {
        b2b.ProductForm.init();
    }

    /**
     * INITIALIZING MODAL(s)
     */
    b2b.modal.init();

    /**
     * INITIALIZING Search Box
     */
    b2b.searchModal.init();

});

/**
 * Shop Page - Variants Image Slider
 */
const $variantSlider = () => {
    let $variantSliders = document.querySelectorAll('.thumb-slider[data-product-id]:not(.slick-initialized)');
    $variantSliders.forEach((slider, index)=>{
        console.log(slider);
        let $productId = slider.getAttribute('data-product-id');
        let $productVariantWrapper = $(`#swiper-${$productId}`);
        if($productVariantWrapper.length) {
            try {
                $productVariantWrapper.slick({
                    slidesToShow: 4,
                    draggable: false,
                    arrows: true,
                    swipe: false,
                    swipeToSlide: false,
                    variableWidth: false,
                    centerMode: false,
                    rows: 0,
                    responsive: [{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                            infinite: false,
                            dots: false,
                            arrows: false,
                            swipe: true,
                            swipeToSlide: true,
                            draggable: true,
                            variableWidth: true,
                            rows: 0
                        }
                    }]
                });
            } catch (e) {
                console.log(e);
            }
        }


    })
}

/**
 *  Shop Page - Switching b/w Variant Images
 */
const $variantImageSwatch = () => {
    let $productItems = $('.woocommerce-loop-product__item');
    $productItems.each(function($index, $productItem){
        let $availableVariants = $($productItem).find('.woocommerce-loop-product__variant.variant-item');
        if($availableVariants.length) {
            $availableVariants.on('click', function (event){
                event.preventDefault();
                let $currentVariant = $(this).parents('.woocommerce-loop-product__variants').find('.active');
                let $mainImage = $(this).parents('.woocommerce-loop-product__item').find('.woocommerce-loop-product__image-wrapper img');
                $currentVariant.removeClass('active');
                let $selectedImage = $(this).find('img').clone();
                $mainImage.replaceWith($selectedImage);
                $(this).addClass('active');
            });
        }
    });
}

const productMainVariantSlider = () => {
    let swiperEle = $('[data-role="product-view-swiper"]');
    if(swiperEle.length) {
        new Swiper('[data-role="product-view-swiper"]', {
            speed: 400,
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
        });
    }
}



const productViewSwitchingVariantInfo = () => {
    let itemThumbs = $('.item-thumb[data-variant]');
    itemThumbs.on('click', function (event){
        event.preventDefault();
        let variantID = $(this).attr('data-variant');
        let currentInfo = $('.item-info.active[data-variant]');
        let currentThumb = $('.item-thumb.active[data-variant]');
        let variantGalleries = $('.product-view__gallery[data-variant]');

        currentInfo.removeClass('active');
        currentThumb.removeClass('active')
        $(this).addClass('active');
        $('.item-info[data-variant="'+variantID+'"]').addClass('active');
        variantGalleries.addClass('d-none');
        $('.product-view__gallery[data-variant="'+variantID+'"]').removeClass('d-none');
    });
}

// Filter Dropdown
b2b.Dropdown = (function() {
    function Dropdown($select) {
        var SELECTOR = '.dropdown-menu'
        var $container = $select.closest(SELECTOR)

        var closing = false

        this.$el = $select

        this.$el.select2({
            theme: 'matsuda',
            minimumResultsForSearch: -1,
            width: '100%',
        })

        this.$el.on('select2:opening', function(e) {
            $('.select2-results').removeClass('active')
        })

        // position and activate dropdown to fix item select click propagation bug
        this.$el.on('select2:open', _.bind(function(e) {
            var $results =  $('.select2-results')
            var $dropdown = $('.select2-results__options')
            var $selectedOption = $dropdown.find('[aria-selected="true"]')
            // var selectedIndex = this.$el.select2('data')[0].element.index
            var selectedIndex = $(e.target).select2('data')[0].element.index
            var menuOffset

            // TODO: value may need to change
            var optionHeight = 27;

            closing = false

            // prevents mousedown from acting on menu ass soon as it appears
            setTimeout(function() {
                if(!closing) {
                    $results.addClass('active')
                }
            }, 300)

            menuOffset = selectedIndex * optionHeight

            var hasNoLabel = $container.hasClass('dropdown-menu--no-label')

            // size the popup to the width of the dropdown control area with
            // different handling depending on presence of a label to the left.
            var menuWidth = hasNoLabel ?
                $container.width() + 16 :
                $container.find('.dropdown-menu__control').outerWidth() + 1

            $dropdown.css({
                marginTop: -36 - menuOffset,
                width: menuWidth
            })
        } ,this))

        this.$el.on('select2:closing', function(e) {
            closing = true
            $('.select2-results').removeClass('active')
        })

        this.$el.on('select2:close', function(e) {
            $('.select2-results').removeClass('active')
        })

        this.$el.on('select2:select', _.bind(function(e) {
            this.$el.trigger({
                type: 'itemSelect.dropdown',
                itemId: e.params.data.id
            })
        }, this))

        return this
    }

    Dropdown.prototype = $.extend({}, Dropdown.prototype, {
        destroy: function() {
            this.$el.select2('destroy')

            this.$el.off('select2:open')
            this.$el.off('select2:closing')
            this.$el.off('select2:select')
        },

        select: function(value) {
            this.$el.val(value).trigger('change')
        }
    })

    return Dropdown;
})()

// Filters In-action
b2b.filters = {
    is_loading: 0,
    totalRecords : null,
    pageLoaded : 1,
    totalPages : null,
    options : {
        filters : ['type', 'collection', 'material', 'shape', 'lens'],
        filterState : {},
        desktopFilters : [],
        hasInitialFilter : false,
        resetEle : '.result-info__reset',
        productItemWrapper : '.products.filter_html',
        resultCountEle : '.result-info__count',
        productItemEle : '.woocommerce-loop-product__item',
        resultInfoEle : '.woocommerce-result-count.result-info',
        filtersWrapperEle : '.woocommerce-filters-wrapper',
        mobileToggleScreen : '991',
        eleRepositionedForMobile : false,
        mobileModalHeaderEle : '[data-role="refine-modal-header"]',
        modalToggleEle : '[data-role="refine-modal-toggle"]',
        modalCloseEle : '[data-role="close-refine"]',
        modalCountCloseBtnEle : '.btn[data-role="close-refine"]',
        modalOpenClass: 'refine-open',
        loaderEle : '#products-loader'
    },
    init : function () {
        let that = this;
        that._initFilterState();
        if(that.options.hasInitialFilter) { // If filters are in query params
            that._updateResults();
        }

        let $resetBtn = $(this.options.resetEle);

        let link = window.location.href;
        if ( link.substring(link.length - 1) === "/" ) {
            link = link.slice(0,-1)
        }
        let coll = link.lastIndexOf('/') + 1;
        if ( link.substring(coll) === "" ) {
            coll = link.lastIndexOf('/') + 1
        }
        let param = link.lastIndexOf('?')
        let collection = ""
        if (param !== -1) {
            collection = link.slice(coll, param);
        } else {
            collection = link.substring(coll);
        }
        if (collection === "shop") {
            collection = "sunglass";
        }

        // Initial Product count, Pages and Size
        let $toolbarEle = $(that.options.resultInfoEle);
        that.totalRecords = parseInt($toolbarEle.attr('data-total-products'));
        that.pageLoaded = parseInt($toolbarEle.attr('data-page-loaded'));
        that.totalPages = parseInt($toolbarEle.attr('data-total-pages'));
        that.options.filterState['p'] = that.pageLoaded;

        // Initializing Dropdown and Filters
        $('.filters .filter').each(function() {
            let $select = $(this).find('select')
            let filterId = $(this).data('filterId')
            let filterDropdown = new b2b.Dropdown($select)

            // initial state from url params
            if (filterId === 'type') {
                filterDropdown.select(collection)
                $(this).find('select').find('option[value="all"]').remove()
            }
            if(that.options.filterState[filterId]) {
                filterDropdown.select(that.options.filterState[filterId])
            }

            $select.on('itemSelect.dropdown', function(e) {
                let $select = $(this);
                let $filter = $select.closest('.filter');
                that._updateFilterState($filter.data('filterId'), e.itemId);
                b2b.block($(that.options.productItemWrapper));
                that._updateResults();
            })
            that.options.desktopFilters.push(filterDropdown);
        });
        $resetBtn.on('click', that._resetRefineFilters);
        this._updateResultCountMb(); // Update Mobile product count
        this._bindModalTriggers(); // Open/Close Modal trigger
        $(window).on('resize', _.debounce(function() {
            if(window.innerWidth > that.options.mobileToggleScreen) {
                $('html').removeClass(that.options.modalOpenClass); // Make sure modal closes on desktop while resizing window.
            }
        }, 200));

        setTimeout(function () {
            $(window).scroll(_.debounce(that._initPaginator.bind(that), 50));
            that._initPaginator();
        }, 3000);
    },
    _initFilterState: function () { // get initial filter state from url params
        let that = this;
        let u = new URLSearchParams(window.location.search);
        that.options.filters.forEach(function(id) {
            if(u.has(id)) {
                that.options.hasInitialFilter = true
                that.options.filterState[id] = u.get(id)
            }
        })

        return that.options.hasInitialFilter;
    },
    _updateFilterState : function (key, value) {
        let that = this;
        that.options.filterState[key] = value === 'all' ? null : value;
        if (key === 'type') {
            let slug = (value) ? value : "all";
            window.location.href = "/product-category/" + slug;
            return;
        }
        that.options.filterState['p'] = 1; // reset the page for new filter state
        that._updateFilterUrlParams();
    },
    _updateFilterUrlParams : function () {
        let that = this;
        if(!window.history.pushState) {
            console.warn('no pushState');
            return
        }

        let u = new URLSearchParams(window.location.search);

        for(let id in that.options.filterState) {
            if(id === 'p') continue;
            if(that.options.filterState[id]) {
                u.set(id, that.options.filterState[id]);
            } else {
                u.delete(id);
            }
        }

        let state;
        if(u.toString().length) {
            state = '?' + u.toString()
        } else {
            let url = new URL(window.location)
            state = url.pathname
        }

        // if these changes need to be navigable (back/fwd button)
        // use pushState instead and will have to add code that
        // responds to state chanages
        window.history.replaceState(null, null, state)
    },
    _updateResults: function (reset) {
        let that = this;
        if(that.is_loading === 0) {
            that.is_loading = 1;
            $(that.options.loaderEle).show(); // show loader
            $.ajax({
                data: {
                    action:'filters',
                    data: that.options.filterState
                },
                type: 'post',
                url:  b2bRequest.ajaxurl,
                success: function(response) {
                    let $toolbarEle = $(that.options.resultInfoEle);
                    let $responseJSON = JSON.parse(response);
                    if($responseJSON.page_loaded === 1) {
                        $(that.options.productItemWrapper).html($responseJSON.html);
                    } else {
                        $(that.options.productItemWrapper).append($responseJSON.html);
                    }
                    if($responseJSON.result_count) {
                        that._updateResultCount($responseJSON.result_count);
                        $toolbarEle.attr('data-total-products', $responseJSON.result_count);
                    }
                    if($responseJSON.page_loaded && parseInt($responseJSON.page_loaded)) {
                        that.pageLoaded = parseInt($responseJSON.page_loaded);
                        $toolbarEle.attr('data-page-loaded', that.pageLoaded);
                    }
                    if($responseJSON.total_pages && parseInt($responseJSON.total_pages)) {
                        that.totalPages = parseInt($responseJSON.total_pages);
                        $toolbarEle.attr('data-total-pages', that.totalPages);
                    }

                    b2b.shopVariantSlider();
                    b2b.shopVariantImageSwatch();
                },
                complete : function () {
                    that.is_loading = 0;
                    b2b.unblock($(that.options.productItemWrapper));
                    $(that.options.loaderEle).hide(); // hiding loader
                }
            });
            that._renderSelectedFilterBadges();
        }
    },
    _initPaginator: function () {
        var self = this,
            scroll_pos = $(window).scrollTop(),
            diff = $(document).height() - $(window).height();
        diff -= 800;
        diff = 0.9 * diff;
        if (scroll_pos >= diff && self.is_loading === 0 && self.pageLoaded < self.totalPages) {
            self.pageLoaded = parseInt(self.pageLoaded + 1);
            self.options.filterState['p'] = parseInt(self.pageLoaded);
            self._updateResults();
        }
    },
    _updateResultCount: function (count) {
        if(count === 1) {
            $(this.options.resultCountEle).text(`${count} result`);
        } else {
            $(this.options.resultCountEle).text(`${count} results`);
        }
        $('[data-total-products]').attr('data-total-products', count);
        this._updateResultCountMb();
    },
    _updateResultCountMb: function () {
        let count = parseInt($('[data-total-products]').attr('data-total-products'));
        count = count ? count : 0;
        if(count === 1) {
            $(this.options.modalCountCloseBtnEle).find('span').text(`See ${count} product`);
        } else {
            $(this.options.modalCountCloseBtnEle).find('span').text(`See ${count} products`);
        }

    },
    _resetRefineFilters : function () {
        let val = window.location.href;
        val = val.split('?')[0];
        window.location.href = val;
    },
    _bindModalTriggers : function () {
        let that = this;
        $(that.options.modalToggleEle).on('click', function (event) {
            event.preventDefault();
            if($(document.body).hasClass(that.options.modalOpenClass)) {
                $(document).trigger('b2b_modal_closed');
            } else {
                $(document).trigger('b2b_modal_opened', [$('.refine-mb__modal')]);
            }
            $(document.body).toggleClass(that.options.modalOpenClass);
        });
        $(that.options.modalCloseEle).on('click', function (event) {
            event.preventDefault();
            $(document).trigger('b2b_modal_closed');
            $(document.body).removeClass(that.options.modalOpenClass);
        });
    },
    _renderSelectedFilterBadges : function () {
        let that = this;
        let $container = $('[data-role="selected-filters"]');
        if($container.length) {
            $container.html('');
            for(let id in that.options.filterState) {
                if(that.options.filterState[id]) {
                    $container.append(`<span class="filtered-badge" data-filter-id="${id}">${that.options.filterState[id]}</span>`);
                }
            }
            /*
            $container.find('> span').on('click', _.debounce(function (event) {
                event.preventDefault();
                let id = $(this).attr('data-filter-id');
                that._updateFilterState(id, 'all');
                that._updateResults();
                that.options.desktopFilters.forEach(function (dropdown) {
                    if(dropdown.$el.attr('id') === 'filter-'+id) {
                        dropdown.select('all');
                    }
                });
            },300));*/
        }
    }

};

// Product Form
b2b.ProductForm = {
    config : {
        formSelector : '.variations_form.cart',
        variantConfig : null,
        formAction : 'b2b_add_variant',
        currentProduct : null
    },
    _formElement : null,
    init : function () {
        let that = this;
        let $formEle = $(that.config.formSelector);
        if($formEle.length) {
            that._formElement = $formEle;
            // Updating variant info
            that.config.variantConfig = JSON.parse($formEle.attr('data-product_variations'));
            that.config.currentProduct = $formEle.attr('data-product_id');

            that._bindControls();

            // While on Product page, If someone makes qty update via Cart Drawer
            // Make sure those qty updates reflects on Product variant form as well.
            $(document.body).on('b2b_cart_items_refreshed', function (event,cart){
                if(cart.cart_items) {
                    $formEle.find('[data-role="qty-input"]').each(function (){
                        let variantId = parseInt($(this).attr('data-variant-id'));
                        if(!variantId) return;
                        let cartItem = cart.cart_items.find((item) => parseInt(item.variant_id) === variantId)
                        if(cartItem && cartItem.qty) {
                            $(this).val(cartItem.qty);
                            $(this).attr('data-value', cartItem.qty);
                        } else { // Means product variant is removed from cart
                            $(this).val(0);
                            $(this).attr('data-value', 0);
                        }
                    })
                }
            })
        }
    },
    _bindControls : function () {
        var that = this;
        if(that._formElement) {
            that._formElement.find('[data-role="qty-box"]').each(function (index, ele){
                let plus = $(ele).find('[data-role="qty-plus"]');
                let minus = $(ele).find('[data-role="qty-minus"]');
                let input = $(ele).find('[data-role="qty-input"]');
                plus.on('click', function (event){
                    event.preventDefault();
                    let currentVal = parseInt(input.val());
                    let maxQty = that._getMaxQtyForVariant(input.attr('data-id'));
                    if(currentVal === maxQty) {
                        alert(`Oops! we can only deliver ${maxQty} qty at the moment.`)
                        input.val(maxQty).trigger('change');
                    } else {
                        if (!isNaN(currentVal)) {
                            input.val(currentVal + 1).trigger('change');
                        } else {
                            input.val(0).trigger('change');
                        }
                    }
                });
                minus.on('click', function (event){
                    event.preventDefault();
                    let currentVal = parseInt(input.val());
                    if (!isNaN(currentVal) && currentVal > 0) {
                        input.val(currentVal - 1).trigger('change');
                    } else {
                        input.val(0).trigger('change');
                    }
                });
            });

            that._formElement.find('[data-role="qty-input"], [data-role="note-input"]').each(function (index, ele){
                $(this).change(_.debounce(function (event) {
                    let id = $(this).attr('data-id');
                    let inputEle = $('[data-id="'+id+'"][data-role="qty-input"]');
                    let qty = parseInt(inputEle.val());
                    let maxQty = that._getMaxQtyForVariant(id);
                    let note = $('[data-id="'+id+'"][data-role="note-input"]').val();
                    if(qty <= maxQty) {
                        that._addToCart({id:id, qty: qty, note:note});
                    } else {
                        inputEle.val(maxQty);
                        that._addToCart({id:id, qty: maxQty, note:note});
                        alert(`Cannot deliver ${qty} qty at the moment.`)
                    }
                },1000))
            });

        }
    },
    _addToCart : function (params) {
        let that = this;
        let vID = parseInt(params.id);
        let attributesInfo = that.config.variantConfig.find((item) => parseInt(item.variation_id) === vID);
        let currentRow = $('.form-row[data-id="'+vID+'"]');
        let extraInfo = {
            productId : that.config.currentProduct,
            action: that.config.formAction,
            security: b2bRequest.security,
            attributes: attributesInfo ? attributesInfo.attributes : false
        };
        currentRow.addClass('in-progress');
        b2b.block(that._formElement);
        $.post(
            b2bRequest.ajaxurl,
            $.extend(params, extraInfo),
            function( response ) {
                // @todo Implement Customer UI responses
                b2b.get_cart_fragment();
            }
        ).done(function(){
            currentRow.removeClass('in-progress');
            b2b.unblock(that._formElement);
        });
    },
    _getMaxQtyForVariant : function (variantId) {
        let that = this;
        let attributesInfo = that.config.variantConfig.find((item) => parseInt(item.variation_id) === parseInt(variantId));
        if(attributesInfo && !isNaN(parseInt(attributesInfo.max_qty))) {
            return parseInt(attributesInfo.max_qty)
        }
        return 0;
    }
};

/**
 * CART drawer
 */

b2b.cartDrawer = {
    options : {
        mainSelector : '#cart-drawer',
        closeSelector : '[data-role="drawer-close"]',
        openSelector : 'header [href$=cart\\/], header [href$=cart]',
        overlaySelector : '.site-nav-scrim',
        formSelector: '.b2b-cart-form',
        updateAction : 'b2b_update_cart',
        removeAction : 'b2b_remove_cart_item'
    },
    init : function () {
        let that = this;
        let $cart = $(that.options.mainSelector);
        if($cart.length === 1) { // double check
            that._bindControls();
        }
        // Check if any fragment is refreshed
        $( document.body ).on( 'b2b_fragments_refreshed', function (){
            that._bindControls();
        } );
    },
    _bindControls : function () {
        let that = this;
        $(that.options.openSelector).on('click', function (event) {
            event.preventDefault();
            that._openIt();
        })
        $(that.options.closeSelector+" ,"+that.options.overlaySelector).on('click', function (event) {
            event.preventDefault();
            that._closeIt();
        })

        that._qtyControls();

    },
    _openIt : function () {
        let that = this;
        let $cart, $overlay;
        $cart = $(that.options.mainSelector);
        $overlay = $(that.options.overlaySelector);
        $(document).trigger('b2b_modal_opened', [$cart]);
        $cart.addClass('active');
        $overlay.addClass('active');
        $(document.body).addClass('cart-open');
    },
    _closeIt : function () {
        let that = this;
        let $cart, $overlay;
        $cart = $(that.options.mainSelector);
        $overlay = $(that.options.overlaySelector);
        $(document).trigger('b2b_modal_closed');
        $cart.removeClass('active');
        $overlay.removeClass('active');
        $(document.body).removeClass('cart-open');
    },
    _qtyControls : function () {
        let that = this;
        let $form = $(that.options.formSelector);
        if($form.length) {
            // Binding Plus/Min Qty Controls
            $form.find('[data-role="qty-box"]').each(function (i, ele) {
                let plus = $(ele).find('[data-role="qty-plus"]');
                let minus = $(ele).find('[data-role="qty-minus"]');
                let input = $(ele).find('[data-role="qty-input"]');
                let addon_prod = $(ele).find('[data-role="addon_product"]');
                //Addon Product Add To Cart
                addon_prod.on('click',function(event){
                    event.preventDefault();
                    let currentVal = parseInt(input.val());
                    let maxQty = parseInt(input.attr('data-max'));
                    let qtyOld = parseInt(input.attr('data-value'));
                    let varID = parseInt(input.attr('data-item'));
                    let prodID = parseInt(input.attr('data-prodid'));
                    let data = { "varID" : varID };
                    if(currentVal > maxQty) {
                        alert(`Oops! we can only deliver ${maxQty} qty at the moment.`)
                        input.val(qtyOld);
                    } else {
                        if (!isNaN(currentVal)) {
                            that._addon_prod(varID,prodID);
                        } else {
                            input.val(0).trigger('change');
                        }
                    }
                });
                plus.on('click', function (event){
                    event.preventDefault();
                    let currentVal = parseInt(input.val());
                    let maxQty = parseInt(input.attr('data-max'));
                    let qtyOld = parseInt(input.attr('data-value'));
                    if(currentVal > maxQty) {
                        alert(`Oops! we can only deliver ${maxQty} qty at the moment.`)
                        input.val(qtyOld);
                    } else {
                        if (!isNaN(currentVal)) {
                            input.val(currentVal + 1).trigger('change');
                        } else {
                            input.val(0).trigger('change');
                        }
                    }
                });
                minus.on('click', function (event){
                    event.preventDefault();
                    let currentVal = parseInt(input.val());
                    if (!isNaN(currentVal) && currentVal > 0) {
                        input.val(currentVal - 1).trigger('change');
                    } else {
                        input.val(0).trigger('change');
                    }
                });
            });

            // Check for any input change and trigger action accordingly
            $form.find('[data-role="qty-input"], [data-role="note-input"]').each(function () {
                $(this).change(_.debounce(function () {
                    let id = $(this).attr('data-id');
                    let inputEle = $('[data-id="'+id+'"][data-role="qty-input"]');
                    let itemId = inputEle.attr('data-item');
                    let qty = parseInt(inputEle.val());
                    let qtyOld = parseInt(inputEle.attr('data-value'));
                    let maxQty = inputEle.attr('data-max');
                    if(qty !== qtyOld) {
                        if(qty === 0) {
                            that._removeItem(itemId);
                        } else if(qty > maxQty) {
                            inputEle.val(qtyOld); //reset the qty
                            alert(`Cannot deliver ${qty} qty at the moment.`)
                        } else {
                            that._updateQty();
                        }
                    }

                },1000))
            });


        }
    },
    _updateQty : function () {
        let that = this;
        let $form = $(that.options.formSelector);
        b2b.block($form);
        let data = $form.serialize();
        let extraData = {
            update_cart: 1,
            action: that.options.updateAction,
            '_wpnonce': b2bRequest.nonceUpdateCart
        };
        extraData = $.param(extraData);
        $.ajax( {
            type:     $form.attr( 'method' ),
            url:      b2bRequest.ajaxurl,
            data:     data+"&"+extraData,
            dataType: 'html',
            success:  function( response ) {
                b2b.render_fragment_response(response);
            },
            complete: function() {
                b2b.unblock( $form );
            }
        } );

    },
    _removeItem : function (itemId) {
        let that = this;
        let $form = $(that.options.formSelector);
        b2b.block($form);
        let data = $form.serialize();
        let extraData = {
            remove_item: itemId,
            action: that.options.removeAction,
            '_wpnonce': b2bRequest.nonceRemoveCart
        };
        $.ajax( {
            type:     $form.attr( 'method' ),
            url:      b2bRequest.ajaxurl,
            data:     data+"&"+$.param(extraData),
            dataType: 'html',
            success:  function( response ) {
                b2b.render_fragment_response(response);
            },
            complete: function() {
                b2b.unblock( $form );
            }
        } );
    },
    _addon_prod : function ( varID, prodID ) {
        let that = this;
        let $form = $(that.options.formSelector);
        b2b.block($form);
        let Data = {
            varID: varID,
            prodID:prodID,
            addtocart: "add_addon",
            update_cart: 1,
            action: that.options.updateAction,
            '_wpnonce': b2bRequest.nonceUpdateCart
        };
        $.ajax( {
            type:     $form.attr( 'method' ),
            url:      b2bRequest.ajaxurl,
            data:     Data,
            dataType: 'html',
            success:  function( response ) {
                b2b.render_fragment_response(response);
            },
            complete: function() {
                b2b.unblock( $form );
            }
        } );
    }
};

// Common Modals
b2b.modal = {
    options : {
        target : '[data-role="b2b-modal"]',
        overlaySelector : '.site-nav-scrim',
    },
    init : function () {
        this._bindControls();
    },
    _bindControls : function () {
        let that = this;
        let $modal = $(that.options.target);
        $($modal.attr('data-trigger')).on('click', function (event) {
            event.preventDefault();
            that._openIt();
        })
        $(that.options.overlaySelector).on('click', function (event) {
            event.preventDefault();
            that._closeIt();
        })

        $modal.find('[data-role="close-modal"]').on('click', function (){
            event.preventDefault();
            that._closeIt();
        })
    },
    _openIt : function () {
        let that = this;
        let $modal, $overlay, $bdClass;
        $modal = $(that.options.target);
        $overlay = $(that.options.overlaySelector);
        $bdClass = $modal.attr('data-bd-class');
        $(document).trigger('b2b_modal_opened', [$modal]);
        $modal.addClass('active');
        $overlay.addClass('active');
        if($bdClass !== '' && $bdClass.length) {
            $(document.body).addClass($bdClass)
        }
    },
    _closeIt : function () {
        let that = this;
        let $modal, $overlay, $bdClass;
        $modal = $(that.options.target);
        $overlay = $(that.options.overlaySelector);
        $bdClass = $modal.attr('data-bd-class');
        $(document).trigger('b2b_modal_closed');
        $modal.removeClass('active');
        $overlay.removeClass('active');
        if($bdClass !== '' && $bdClass.length) {
            $(document.body).removeClass($bdClass)
        }
    },
};

b2b.searchModal = {
    options : {
        element : 'a[href="#search"]',
        container : '#search-container'
    },
    init : function () {
        let that = this;
        $(that.options.element).on('click', function (){
            $(that.options.container).show();
            $('.site-nav-scrim').trigger('click'); // hide the navigation
        })
        if(window.location.hash === '#search') {
            $(that.options.container).show();
        }
    }
};




/**
 *
 *  Cart View Page
 */
var cartBinding = function () {
    let $cartForm = $('body .main-container form.woocommerce-cart-form');
    $cartForm.find('[data-role="qty-box"]').each(function (i, ele) {
        let plus = $(ele).find('[data-role="qty-plus"]');
        let minus = $(ele).find('[data-role="qty-minus"]');
        let input = $(ele).find('[data-role="qty-input"]');
        plus.on('click', function (event){
            event.preventDefault();
            let currentVal = parseInt(input.val());
            let maxQty = parseInt(input.attr('data-max'));
            let qtyOld = parseInt(input.attr('data-value'));
            if(currentVal > maxQty) {
                input.val(qtyOld);
            } else {
                if (!isNaN(currentVal)) {
                    input.val(currentVal + 1).trigger('change');
                } else {
                    input.val(0).trigger('change');
                }
            }
        });
        minus.on('click', function (event){
            event.preventDefault();
            let currentVal = parseInt(input.val());
            if (!isNaN(currentVal) && currentVal > 0) {
                input.val(currentVal - 1).trigger('change');
            } else {
                input.val(0).trigger('change');
            }
        });
    });
    $cartForm.find('[data-role="qty-input"]').each(function () {
        $(this).change(_.debounce(function () {
            $cartForm.find('[name="update_cart"]').trigger('click');

        },1000))
    });
}
$(function (){ // On ready
    cartBinding();
    $(document.body).on('updated_wc_div', function (){
        cartBinding();
    })

    // Catalog Search
    let $searchCountEle = $('[data-role="search-count"]');
    let $searchReset = $('[data-role="search-reset"]');
    let $searchControl = $('[data-role="search-control"]');
    $searchReset.on('click', function (event){
        event.preventDefault();
        $('#catalog-search-input').val('').focus();
        $searchCountEle.text('');
        $("#catalog-search-results").html('');
        $searchControl.addClass('d-none');
    })
    $('#catalog-search-input').on('keydown', _.debounce(function(){
        let searchKeyword = $(this).val().trim();
        if(searchKeyword.length > 3) { // Keyword has at least 4 alphabet
            let formdata = new FormData();
            formdata.append('action','b2b_search_data');
            formdata.append('security',b2bRequest.searchSecurity)
            formdata.append('data',searchKeyword);
            $.ajax({
                data: formdata,
                type: 'post',
                contentType: false,
                processData: false,
                url:  b2bRequest.ajaxurl,
                success: function(data) {
                    let response = JSON.parse(data);
                    $("#catalog-search-results").html(response.html);
                    if(parseInt(response.result_count) > 0) {
                        $searchCountEle.text(`${response.result_count} Product Results`)
                    } else {
                        $searchCountEle.text(`0 Results`)
                    }
                },
                error : function (jqXHR, errorThrown) {
                    // console.log(jqXHR, errorThrown);
                },
                complete : function () {
                    $searchControl.removeClass('d-none');
                }
            });
        }

    }, 300));

    // Password Astrisk
    let $asteriskFields = $('.password-asterisk-field');
    $asteriskFields.each(function ($index, $field){
        let $input = $($field).find('[type="password"]');
        let $inputOverlay = $($field).find('.password-asterisk-overlay');
        if(!$input.length || !$inputOverlay.length) {
            return false;
        }
        $input.on('keyup', () => {
            let $inputOverlayText = Array($input.val().length).fill('*').join('');
            $inputOverlay.html($inputOverlayText);
        })
    })
});




// $(document).on('change','.dropdown-menu__control select',function(e){
//     e.preventDefault();
//     let filter_arr = [];
//     //alert($(this).val());
//     $('.dropdown-menu__control select').each(function(i, obj) {
//         console.log("=============================================");
//         let data = {};
//         let option_name = $(this).parents('.filter').data('filter-id'),
//             option_value = $(this).val();
//         data[option_name] = option_value;
//         filter_arr.push(data);
//     });
//     console.log(filter_arr);
//     $.ajax({
//         data: {
//             action:'filters',
//             data: filter_arr
//         },
//         type: 'post',
//         url:  b2bRequest.ajaxurl,
//         success: function(data) {
//             console.log(data);
//     }
// });
// });